var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawHappyFsrv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 576.556,
    height: 800,
    viewBox: "0 0 576.556 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1080.185 -110.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.464,2.711,5.721,0l-8.4,17.018L13.4,19.133Z",
    transform: "translate(1174.97 822.138)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.678,2.711,15.064,0l8.4,17.018L7.385,19.133Z",
    transform: "translate(1392.331 825.043)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.554,548.478,697.14,554,804.831,406.647l80.014,149.744,20.441-4.769L847.459,340.5H772.493Z",
    transform: "translate(504.629 275.313)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.961,722.537h0a7.686,7.686,0,0,0,5.857-.754l37.2-21.418a7.549,7.549,0,0,0,1.571-11.88l-3.325-3.325-17.639-1.47-26.965,25.887a7.686,7.686,0,0,0,3.3,12.96Z",
    transform: "translate(123.6 149.673)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.592,728.638h0a7.686,7.686,0,0,1-5.857-.754l-37.2-21.418a7.549,7.549,0,0,1-1.571-11.879l3.325-3.325,17.639-1.47,26.965,25.887a7.686,7.686,0,0,1-3.3,12.96Z",
    transform: "translate(627.369 149.452)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.77,214l7.35,4.41,15.231-24.75a11.131,11.131,0,0,0-7.187-16.726h0A11.131,11.131,0,0,0,785.769,187Z",
    transform: "translate(618.297 168.096)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.8,415.058l-3.049-8.01-27.274,10.033a11.131,11.131,0,0,0-4.695,17.589h0a11.131,11.131,0,0,0,16.753.368Z",
    transform: "translate(140.671 159.725)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.049,
    cy: 22.049,
    rx: 22.049,
    ry: 22.049,
    transform: "translate(1291.821 426.191)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.019,214.034h30.869V180.226l-26.459-2.94Z",
    transform: "translate(530.742 281.243)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.889,461.377h83.786c-2.954-46.749-5.294-91.927,0-117.6L941.8,320.4a13.176,13.176,0,0,0-14.533-10.387l-11.464,1.433c-7.764,13.649-17.146,13.517-27.929,1.47H874.069a13.843,13.843,0,0,0-13.841,14.117h0a174.868,174.868,0,0,0-3.553,50.188Z",
    transform: "translate(409.823 163.255)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.464,97.745,735.7,91.866,672.5,196.232l17.639,26.458Z",
    transform: "translate(666.362 284.347)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.834,415.812l-10.05-8.477,53.4-74.827a47.327,47.327,0,0,1,47.069-19.057l1.685.309L1006.746,349.1l-26.595,20.135Z",
    transform: "translate(263.47 163.154)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876,269.726s-4.12-9.064,6.592-13.184c0,0,9.064-14.832,27.193-4.944,0,0,12.36,4.944,12.36,18.129s4.12,15.656,4.12,15.656-6.136-6.295-7.784-11.239-14.465-6.066-19.409-1.122-17.3,4.12-17.3,4.12l.824,18.129s-4.12-10.712-5.768-10.712S873.526,269.726,876,269.726Z",
    transform: "translate(412.373 165.497)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.423,
    cy: 8.954,
    rx: 174.423,
    ry: 8.954,
    transform: "translate(1129.541 892.192)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1178.637 305.324) rotate(-21.162)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1133.508 409.869) rotate(-21.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1124.776, 456.327)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1141.351, 387.968)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1161.523, 302.066)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.066,
    cy: 7.282,
    rx: 5.066,
    ry: 7.282,
    transform: "translate(1256.329 314.213) rotate(-49.596)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.066,
    cy: 7.282,
    rx: 5.066,
    ry: 7.282,
    transform: "translate(1321.52 337.272) rotate(-49.596)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.602,
    cy: 3.202,
    rx: 4.602,
    ry: 3.202,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 1373.357, 327.49)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.602,
    cy: 3.202,
    rx: 4.602,
    ry: 3.202,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 1305.352, 345.463)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.602,
    cy: 3.202,
    rx: 4.602,
    ry: 3.202,
    transform: "matrix(0.746, -0.666, 0.666, 0.746, 1268.437, 335.474)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.602,
    cy: 3.202,
    rx: 4.602,
    ry: 3.202,
    transform: "translate(1527.134 379.218) rotate(-18.343)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1343.264 280.538) rotate(-21.162)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1291.945 326.885) rotate(-21.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1299.789, 304.984)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1326.15, 277.278)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.066,
    cy: 7.282,
    rx: 5.066,
    ry: 7.282,
    transform: "translate(1521.022 411.316) rotate(-49.596)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1238.819 325.21) rotate(-21.162)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1233.429 249.47) rotate(-21.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1174.461, 358.512)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1195.343, 349.657)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1221.705, 321.952)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1533.473 292.035) rotate(-21.162)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1477.491 276.097) rotate(-21.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1468.76, 322.556)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1485.334, 254.197)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1516.359, 288.777)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1545.229, 328.409)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1309.185 247.151) rotate(124)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(-0.669, 0.743, -0.743, -0.669, 1188.773, 335.407)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1140.235 238.69) rotate(-21.162)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 5.066,
    rx: 7.282,
    ry: 5.066,
    transform: "translate(1095.106 343.236) rotate(-21.162)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1080.185, 331.496)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1096.759, 263.138)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.202,
    cy: 4.602,
    rx: 3.202,
    ry: 4.602,
    transform: "matrix(0.973, -0.23, 0.23, 0.973, 1123.121, 235.432)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1365.54 110.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.343,0A48.665,48.665,0,0,0,56.678,48.665c0,22.6,19.816,52.036,38.4,66.527a15.754,15.754,0,0,0,5.479,2.75l1.825,6.57a3.156,3.156,0,0,0,3.041,2.311h.231a3.156,3.156,0,0,0,3.081-2.471l1.5-6.751a16.252,16.252,0,0,0,4.588-2.52c20.795-16.283,39.187-43.05,39.187-66.417A48.665,48.665,0,0,0,105.343,0Z",
    transform: "translate(-56.678)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.038,125.374c-5.848,14.651-10.551,11.313-14.747,0v-2.949h14.747v2.949Z",
    transform: "translate(-58.262 -4.448)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.636,123.962l-.332,27.805-.015.944-.066,96.593v4.483l-.015,1.416h-1.482l.015-1.342V249.3l.074-96.593.081-6.658.265-22.106Z",
    transform: "translate(-58.496 -4.504)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.233,255.191h-1.489l-.14-1.342-.029-4.557-.6-96.593-3.038-28.919,1.467-.155,2.352,22.415.7,6.658.295,96.593.007,1.423.324,3.06Z",
    transform: "translate(-58.358 -4.492)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747,123.78,109.709,152.7l-.855,96.593-.052,5.9h-1.349l.472-4.476.007-1.423.295-96.593.1-.944,2.949-28.13Z",
    transform: "translate(-58.522 -4.492)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1521.021 209.603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.046,134.2a37.719,37.719,0,0,0-53.058,5.509c-11.042,13.6-13.5,40.993-9.4,58.791a12.211,12.211,0,0,0,1.953,4.332l-2.112,4.845a2.446,2.446,0,0,0,.7,2.876l.139.113a2.446,2.446,0,0,0,3.061.018l4.2-3.329a12.6,12.6,0,0,0,3.992.725c20.468.361,44.612-6.76,56.028-20.821a37.719,37.719,0,0,0-5.509-53.058Z",
    transform: "translate(-626.272 -125.763)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.371,209.825s-3.806-1.884-19.177,16.921-42.306,58.3-42.306,58.3l-2.19,2.7-.7.845-.892-.724.664-.8L626,284.322s27.452-40.356,42.826-59.163S687.491,209.1,687.491,209.1Z",
    transform: "translate(-623.106 -127.822)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1131.469 116.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.528,133.508a34.626,34.626,0,0,1,48.707,5.057c10.137,12.486,12.391,37.631,8.625,53.969a11.209,11.209,0,0,1-1.793,3.976L754,200.958a2.245,2.245,0,0,1-.643,2.64l-.128.1a2.245,2.245,0,0,1-2.81.017l-3.856-3.056a11.565,11.565,0,0,1-3.664.665c-18.789.331-40.953-6.206-51.433-19.114a34.626,34.626,0,0,1,5.057-48.707Z",
    transform: "translate(-683.726 -125.763)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.106,209.754s3.494-1.73,17.6,15.533,38.836,53.519,38.836,53.519l2.01,2.476.643.775.819-.665-.61-.735-2.044-2.517s-25.2-37.047-39.314-54.311-17.138-14.746-17.138-14.746Z",
    transform: "translate(-558.429 -134.476)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawHappyFsrv);
export default __webpack_public_path__ + "static/media/undraw_happy_fsrv.422d81b1aacc0659f6cc1661b927bc8e.svg";
export { ForwardRef as ReactComponent };